export default __webpack_public_path__ + "static/media/riftboundLogo.b975dfbe.png";